<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-item-end">
        <ts-input
          v-tooltip="$t('productProfile.returnToVendorSearch')"
          v-model="search"
          :placeholder="$t('productProfile.returnToVendorSearch')"
          style="width: 100%;"
          class="inline-block"
        />
      </div>
      <div class="overflow-auto ts-mt-3">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.return_date }}</td>
            <td>{{ record.return_number }}</td>
            <td>{{ record.vendor_name }}</td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.status == 'Completed'"
                >{{ record.status }}</span
              >
              <span class="badge badge-danger" v-else>{{ record.status }}</span>
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_refund_received"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td>{{ record.remarks }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'returnToVendor',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/productDetailReturnToVendor', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.productDetailReturnToVendor.search
      },
      set(newValue) {
        this.$store.commit('product/productDetailReturnToVendor/SET_SEARCH', newValue)
        this.$store.commit('product/productDetailReturnToVendor/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('productProfile.returnDate'), style: 'width: 7%' },
        { name: this.$t('productProfile.returnNumber') },
        { name: this.$t('productProfile.vendor') },
        { name: this.$t('productProfile.status') },
        { name: this.$t('productProfile.refundReceived'), style: 'text-align:center' },
        { name: this.$t('productProfile.remark') }
      ]
    }
  },
  methods: {
    ...mapActions('product/productDetailReturnToVendor', ['fetch']),
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
